module.exports = __webpack_public_path__ + "img/u.7a81ad1f.jpg";